<script>
// import Translations from "./insert-me-to-translate.vue";
import Url from "domurl";

import { 
  privacyCookieName,
  getLightboxName,
  canUseCookies,
} from '../utils';

const cookieName = 'adult_cookie';

export default {
  props: {
    privacyCookie: {
      type: Boolean,
      required: true,
      default: false
    },
    tcUrl: {
      type: String,
      required: true
    },
    isVivaincontri: {
      type: Boolean,
      default: false
    },
  },
  components: {
    SvgVm18Skokka: () => import(/* webpackChunkName: "chunck-svg-vm18-skokka" */ './svg/vm18-skokka.vue'),
    SvgVm18Vivaincontri: () => import(/* webpackChunkName: "chunck-svg-vm18-vivaincontri" */ './svg/vm18-vivaincontri.vue')
  },
  data() {
    return {
      lightboxName: null,
      adultCookie: false,
      i18n: {
        pleaseRead: gettext("Please read the following warning before continuing"),
        eighteenYearOld: String(gettext(" <b>I am over 18 years old</b>  and I accept the viewing of explicit texts and images intended for an <b>adult audience</b><br>")).replace("<br>", ".<br>"),
        accept: gettext("Accept"),
        refuse: gettext("Decline"),
        termsAndConditions: String(gettext("I have read and accept the<br> <a data-href='##tcUrl##'>Terms and Conditions</a>")).replace("##tcUrl##", this.tcUrl)
      }
    }
  },
  computed: {
    shown() {
      return this.$store.getters['ui/lightboxManager/lightboxIsShown'](this.lightboxName);
    }
  },
  mounted() {
    this.lightboxName = getLightboxName({ el: this.$el });
    /**
      Manage the display status of cookies based on the presence of cookies and the user's country, when privacy cookies are enabled.
      In countries where privacy cookies are required, both the adult cookie and the privacy cookie need to be checked.
      In countries where privacy cookies are not required, only the adult cookie needs to be checked.
    */
    const requiresPrivacyCookie = locations.privacy_cookie_country || false;
    const hasCookie = !!this.$cookies.get(cookieName) || false;
    const hasPrivacyCookie = !!this.$cookies.get(privacyCookieName) || false;
    const url = new Url(window.location.href);
    
    const isLightboxQueryPresent = url.query.lightbox === 'true';

    const shouldRemoveFromQueue = requiresPrivacyCookie ? (hasCookie && hasPrivacyCookie) : hasCookie;

    if (shouldRemoveFromQueue && !isLightboxQueryPresent) {
      this.$store.dispatch("ui/lightboxManager/removeAndHide", this.lightboxName);
    }
  },
  watch: {
    privacyCookie() {
      if (this.privacyCookie && this.adultCookie) {
        this.$cookies.set(cookieName, '1', '1d', '/', locations.cookie_domain);
      }
    }
  },
  methods: {
    accept() {
      if (canUseCookies) {
        this.$cookies.set(cookieName, '1', '1d', '/', locations.cookie_domain);
      } else {
        this.adultCookie = true;
      }
      this.$store.dispatch("ui/lightboxManager/hide");
    },
  },
};
</script>

<template >
  <div class="modal modal-vm18 fade" id="exampleModalCenter" tabindex="-1" :class="{ show: shown }" :style="shown ? 'display: block;' : 'display: none;'" role="dialog" aria-labelledby="exampleModalLabel" data-backdrop="static" style="display: block; padding-left: 0px;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content py-md-5 px-md-4 p-sm-3 p-4 text-center">
      <svg-vm18-vivaincontri v-if="isVivaincontri" class="mx-auto" />
      <svg-vm18-skokka v-else class="mx-auto" />
        <p class="mt-4 emoji-l">
          <b v-html="i18n.pleaseRead"></b>
        </p>
        <!-- Default slot -->
        <slot>
          <p class="r3 px-md-5 px-sm-1" v-html="i18n.eighteenYearOld"></p>
          <hr class="my-1 border-0">
          <span v-html="i18n.termsAndConditions"></span>
        </slot>
        <p></p>
        <div class="text-center mb-3">
          <button class="btn btn-primary w-50 rounded-pill b1" @click="accept" v-html="i18n.accept"></button>
        </div>
        <a href="https://www.google.com" rel="noopener nofollow" class="text-center no-underline" data-dismiss="modal"
          v-html="i18n.refuse"></a>
      </div>
    </div>
  </div>
</template>